<template>
  <div class="statistics-page">
    <topSearchForm @search="query" @export="daochu">
      <el-form :inline="true" class="curForm" label-position="left">
        <el-form-item label="保单号" class="item">
          <el-input type="text" placeholder="请输入保单号" v-model="search.policyNo" class="code"></el-input>
        </el-form-item>
        <el-form-item label="犹豫到期" class="item1">
          <a-range-picker v-model="search.sureDate" format="yyyy-MM-DD" @change="dateChange" valueFormat="yyyy-MM-DD" separator="至">
            <i class="icon-riqixuanze" slot="suffixIcon"></i>
          </a-range-picker>
        </el-form-item>
      </el-form>
    </topSearchForm>
    <div class="content">
      <el-table class="list-table" v-loading="listLoading" :summary-method="getSummaries" sum-text border show-summary :data="tableData" tooltip-effect="dark">
        <emptyBox slot="empty"></emptyBox>
        <el-table-column type="index" width="80px" show-overflow-tooltip></el-table-column>
        <el-table-column property="policyNo" label="保单号" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column property="productName" label="产品名称" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column property="waverLimitDate" label="犹豫到期" min-width="170" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.waverLimitDate }}</span>
          </template>
        </el-table-column>
        <el-table-column property="payTime" label="出单时间" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.payTime | timeSubstr(0, 16) }}</span>
          </template>
        </el-table-column>
        <el-table-column property="mechanName" label="所属机构" min-width="180" show-overflow-tooltip> </el-table-column>
        <el-table-column property="fee" label="保费（元）" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column property="payNum" label="年限" min-width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.payNum == 1">首年</span>
            <span v-else>第{{ scope.row.payNum }}年</span>
          </template>
        </el-table-column>
        <el-table-column
          property="baseIncome"
          :label="userinfo.level == 1 || userinfo.level == 2 ? '基础服务费（元）' : '服务费（元）'"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span>{{ scope.row.baseIncome || '--' }}</span>
            <el-popover placement="top" trigger="hover">
              <div>
                <span>基础服务费：</span>
                <span>{{ scope.row.baseIncome || '--' }}</span>
              </div>
              <div>
                <span>主险基础服务费：</span>
                <span>{{ scope.row.mainIncomes || '--' }}</span>
              </div>
              <div>
                <span>附加险基础服务费：</span>
                <span>{{ scope.row.additionIncomes || '--' }}</span>
              </div>
              <span v-if="scope.row.additionIncomes != '0.00'" slot="reference" class="wenhao">?</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          property="subsidyIncomes"
          label="活动奖励（元）"
          v-if="userinfo.level == 1 || userinfo.level == 2"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.subsidyIncomes">{{ scope.row.subsidyIncomes }}</span>
            <span v-else>--</span>
            <activityTip
              v-if="scope.row.activityName"
              :activityName="scope.row.activityName"
              :subsidyCommission="scope.row.subsidyCommissionVal"
              :subsidyIncomes="scope.row.subsidyIncomes"
            ></activityTip>
          </template>
        </el-table-column>
        <el-table-column
          property="totalIncome"
          label="合计（元）"
          v-if="userinfo.level == 1 || userinfo.level == 2"
          min-width="150"
          fixed="right"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page.sync="pageNum"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList(1);
        "
        :layout="$tools.pageLayout"
        @current-change="getList"
        :total="total"
        :page-size="pageSize"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import topSearchForm from "@/components/topSearchForm";
import activityTip from "@/components/activityTip";
//当前实例组件
export default {
  data: () => ({
    listLoading: true,
    search: {
      policyNo: "",
      twoMechanName: "",
      sureDate: [],
      sureDateStart: "",
      sureDateEnd: ""
    },
    pageSize: 10,
    total: 0,
    tableData: [],
    pageNum: 1,
    sureDate: "",
    userinfo: {}
  }),
  components: { topSearchForm, activityTip },
  created() {
    this.userinfo = this.$tools.getLocal("userinfo");
    console.log(this.userinfo);
    this.getList();
  },
  methods: {
    dateChange(date) {
      if (date && date.length) {
        this.search.sureDateStart = date[0];
        this.search.sureDateEnd = date[1];
      } else {
        this.search.sureDateStart = "";
        this.search.sureDateEnd = "";
      }
    },
    daochu: function () {
      const params = this.getParams();
      this.$tools.daochu("/master/mechan/export/oneCommissonsSum", params);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    query: function () {
      this.pageNum = 1;
      this.getList(1);
    },
    changeTime: function (data) {
      this.pageNum = 1;
      this.getList(1);
    },
    handleCurrentChange: function (val) {
      this.getList(val);
    },
    getSummaries: function (param) {
      //合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          index === 0 ||
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 5 ||
          index === 7
        ) {
          sums[index] = "——";
          return;
        }
        let values;
        values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    getParams() {
      const params = {
        sureDateStart: this.search.sureDateStart,
        sureDateEnd: this.search.sureDateEnd,
        policyNo: this.search.policyNo
      };
      return params;
    },
    getList: function (num) {
      const params = this.getParams();
      params.pageSize = this.pageSize;
      params.pageNum = num;
      this.listLoading = true;
      this.$http({
        url: "/master/mechan/queryOneCommissonsSum",
        type: "put",
        params: params
      }).then((data) => {
        this.listLoading = false;
        this.tableData = data.data;
        this.total = data.total;
      });
    }
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
.curForm {
  .item {
    width: 30%;
  }
  .item1 {
    width: 40%;
  }
}
</style>